module.exports = __webpack_public_path__ + "img/stat.93560616.svg";